<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" class="refund-search" :search-condition="searchCondition"
        :search-buttons="searchButtonList" :validFunction="validSearchParams"
        :fuzzySearchPlaceholder="fuzzySearchPlaceholder" :showMerchantSearch="true" router-name="/transaction/refund">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getRefundList" :first-parameters="getInitParams()"
        :showMerchantNo="true" ref="table" router-name="/transaction/refund">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>

import { getQueryCardTypes } from '@/api/common';
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getTodayParams, initDaysRangeByToday, formatDateDisplay } from '@/utils/tools/time';
import ApplicationService from '@/views/application/api/application-list.service';
import RefundService from '@/views/transaction/api/refund-manage.service';
import { OnlineRefundStatus, RefundAuditStatus, QueryHistoryOptions } from '@/views/transaction/status/transaction';

export default {
  components: {
    SearchComponent,
    CustomTable,
    CustomMessage,
  },
  data() {
    return {
      getTodayParams,
      ...RefundService,
      downloading: false,
      transactionUrlList: [],
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.originalTxnSerialNumber')};${this.$t('message.tableCommon.merchantOrderNumber')}`,
      searchCondition: [
        {
          key: ['startTime', 'endTime'],
          name: 'message.tableCommon.refundTime',
          defValue: initDaysRangeByToday(-2),
          type: 'date_time',
        },
        {
          key: 'isHistory',
          name: 'message.tableCommon.queryHistory',
          type: 'select',
          defValue: '1',
          options: QueryHistoryOptions,
          isInternationalization: true,
        },
        // {
        //   key: 'txnId',
        //   name: 'message.tableCommon.txnSerialNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        // {
        //   key: 'merchantTxnId',
        //   name: 'message.tableCommon.merchantOrderNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        {
          key: 'onlineRefundStatus',
          name: 'message.tableCommon.onlineRefundStatus',
          type: 'select',
          defValue: [''],
          isInternationalization: true,
          options: OnlineRefundStatus,
          multiple: true,
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }
            this.$refs.search.setInputValue('onlineRefundStatus', list);
          },
        },
        {
          key: 'auditStatus',
          name: 'message.tableCommon.auditStatus',
          type: 'select',
          defValue: '',
          isInternationalization: true,
          options: RefundAuditStatus,
        },
        {
          key: 'cardType',
          name: 'message.tableCommon.cardType',
          type: 'select',
          defValue: '',
          options: [],
        },
        {
          key: 'appIds',
          name: 'message.transaction.transactionURL',
          type: 'select',
          multiple: true,
          defValue: [''],
          options: [],
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }
            this.$refs.search.setInputValue('appIds', list);
          },
        },
        {
          key: 'email',
          name: 'message.transaction.customerEmail',
          type: 'input',
          defValue: '',
        },

      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'transaction:refund:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await RefundService.downloadRefund(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundTime' },
          key: 'refundTime',
          type: 'text',
          itemWidth: 208,
        },
        {
          key: 'originTxnId',
          titleBar: { title: 'message.transaction.originTxnId', type: 'text' },
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'originTxnId',
              func: (data) => {
                const params = {
                  id: data.originTxnId,
                };
                // if (this.isQueryHistory) {
                //   params.isHistory = '1';
                // }
                this.$router.push({
                  path: '/transaction/details',
                  query: params,
                });
              },
            },
          ],
          itemWidth: 250,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundSerialNumber' },
          key: 'id',
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'id',
              func: (data) => {
                const params = {
                  id: data.id,
                };
                // if (this.isQueryHistory) {
                //   params.isHistory = '1';
                // }
                this.$router.push({
                  path: '/transaction/refund/details',
                  query: params,
                });
              },
            },
          ],
        },
        // {
        //   key: 'txnId',
        //   titleBar: { title: 'message.tableCommon.txnSerialNumber', type: 'text' },
        //   type: 'click',
        //   subTableDisplays: [
        //     {
        //       type: 'link',
        //       key: 'txnId',
        //       isInternationalization: true,
        //       router: '/transaction/details',
        //       valueKey: ['txnId'],
        //       paramsKey: ['id'],
        //     },
        //   ],
        // },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber' },
          key: 'merchantTxnId',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundAmount' },
          key: 'refundAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.refundAmount && data.refundAmount.currency, data.refundAmount && data.refundAmount.amount),
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.auditStatus' },
          key: 'auditStatus',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => getEnantiomericValue(RefundAuditStatus, data.auditStatus),
          itemStyle: (data) => {
            if (data.auditStatus === 'unnecessary' || data.auditStatus === 'pass') {
              return 'background:rgba(0,221,40,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.auditStatus === 'waiting') {
              return 'background:rgba(255,178,9,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.auditStatus === 'cancel') {
              return 'background:#F1F5F7;padding:2px 8px;border-radius:4px;';
            }
            return 'background:rgba(252,100,45,0.15);padding:2px 8px;border-radius:4px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnTime' },
          key: 'txnTime',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardType' },
          key: 'cardType',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.orderAmount' },
          key: 'txnAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.onlineRefundStatus' },
          key: 'status',
          type: 'text',
          isInternationalization: true,
          // isDisplayFunc: (data) => data.status !== 'I',
          textFunc: (data) => {
            if (!data.status || data.status === 'E') {
              return 'message.status.pending';
            }
            return getEnantiomericValue(OnlineRefundStatus, data.status);
          },
          itemStyle: (data) => {
            if (data.status === 'S' || data.status === 'pass') {
              return 'background:rgba(0,221,40,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.status === 'F') {
              return 'background:rgba(252,100,45,0.15);padding:2px 8px;border-radius:4px;';
            } else if (data.status === 'N') {
              return 'background:#F1F5F7;padding:2px 8px;border-radius:4px;';
            }
            return 'background:rgba(255,178,9,0.15);padding:2px 8px;border-radius:4px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.transactionURL' },
          key: 'website',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.customerEmail' },
          key: 'email',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.refundsRevoke',
              permissionCode: 'transaction:refund:revoke',
              isDisplayFunc: (data) => {
                // if (this.isQueryHistory) {
                //   return false;
                // }
                return data.auditStatus && data.auditStatus === RefundAuditStatus[1].value;
              },
              func: (data) => {
                this.$refs.customMessage.openHttpModal({
                  titleHtml: this.$t('message.common.prompt'),
                  contentHtml: this.$t('message.settlement.refundsRevokeConfirm'),
                  httpFunction: this.postRefundRevoke,
                  params: { ids: [data.id] },
                  successFunction: this.onRefreshTable,
                });
              },
            },
          ],
        },
      ],
      // isQueryHistory: this.$route.query.isHistory === '1',
    };
  },
  methods: {
    // 默认参数和查询条件保持一致
    getInitParams() {
      const time = initDaysRangeByToday(-2);
      return {
        startTime: formatDateDisplay(time[0]),
        endTime: formatDateDisplay(time[1]),
        // isHistory: '1',
        completed: '',
      };
    },
    /**
     * 刷新当前表单
     */
    onRefreshTable() {
      this.$refs.table.refreshTable();
    },
    /**
     * 初始化卡种
     */
    initCardTypes() {
      getQueryCardTypes('').then((data) => {
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('cardType', initSelectedData(data, ''));
        }
      }).catch(() => ({}));
    },
    // 获取交易网址
    async queryTransactionUrlList() {
      const res = await ApplicationService.getApplicationList({ size: -1 });
      this.transactionUrlList.push({ label: this.$t('message.checkout.allWebsite'), value: '' });
      res.content.forEach((item) => {
        this.transactionUrlList.push({ label: item.website, value: item.id });
      });
      if (this.$refs.search) {
        this.$refs.search.setSearchSelectOptions('appIds', this.transactionUrlList);
      }
    },
    validSearchParams(params) {
      if (params.keywords) {
        return true;
      }
      if (!params.startTime && !params.endTime) {
        ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.tableCommon.refundTime') }));
        return false;
      }
      if (params.startTime || params.endTime) {
        if (!params.startTime) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.tableCommon.refundTime') }));
          return false;
        }
        if (!params.endTime) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.tableCommon.refundTime') }));
          return false;
        }
      }

      try {
        // this.isQueryHistory = params.isHistory === '1';
        if (this.$refs.search) {
          this.$refs.search.initSearchButtons();
        }
      } catch (err) {
        //
      }

      return true;
    },
  },
  created() {
    this.queryTransactionUrlList();
  },
  mounted() {
    this.initCardTypes();
  },
};
</script>
<style lang="scss">
#refundDetail .is-bordered-label {
  width: 50%;
}

html[lang=en] .refund-search .fuzzy-input-box {
  width: 536px !important;
}
</style>
